import { ChevronRight } from 'lucide-react';
import React from 'react';

interface AccountMenuItem {
  id?: string | number;
  title?: string;
  desc?: string;
  icon?: string;
  onClick?: () => void;
}

interface CardSettingAccount {
  sectionTitle?: string;
  items: AccountMenuItem[];
}

const CardSettingAccount = ({ sectionTitle, items }: CardSettingAccount) => {
  return (
    <div className="shadowCard p-3 flex flex-col gap-3 ">
      <h3 className="title3 text-text-grey capitalize">{sectionTitle}</h3>

      <div className="flex flex-col gap-3 w-full items-start">
        {items.map((item) => {
          const icon = item.icon;
          return (
            <button
              key={item.id}
              onClick={item.onClick}
              type="button"
              className="w-full justify-between inline-flex gap-3 items-center text-start p-3"
            >
              <div className="inline-flex gap-3 items-center min-w-0">
                <figure className="shrink-0">
                  <img src={icon} alt={item.title} className="w-auto h-auto" loading="eager" />
                </figure>
                <div className="min-w-0">
                  <p className="truncate title2medium text-black">{item.title}</p>
                  <p className="truncate reg12 text-text-grey">{item.desc}</p>
                </div>
              </div>
              <div className="shrink-0 ml-auto">
                <ChevronRight />
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default CardSettingAccount;
